/* eslint-disable */
<template>
  <!--############## SHIPPING SECTION ###############-->
  <div class="container-fluid text-center bg-grayish-white offer pt-5 pb-5 d-none d-md-block">
    <div class="container">
      <div class="row">
        <div class="col-md-4 m-right">
          <h4>
            <i class="fa fa-cart-plus mr-3" aria-hidden="true"></i>
            FREE SHIPPING
          </h4>
          <p>On Other Over 90$</p>
        </div>
        <div class="col-md-4 m-right">
          <h4><i class="fa fa-phone mr-3" aria-hidden="true"></i>CALL US ANYTIME</h4>
          <p>+2349059053779</p>
        </div>
        <div class="col-md-4">
          <h4><i class="fa fa-map-marker mr-3" aria-hidden="true"></i>OUR LOCATION</h4>
          <p>Lagos, Nigeria</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Shipping"
};
</script>

<style></style>
